<section class="notes-section">
  <ng-container *ngIf="notesData.isLoading">
    <div class="head-text">
      All Worksheet Notes
    </div>
    <ul nz-menu class="note-skeleton">
      <li
        *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6]"
        style="padding: 0px 15px 0px 15px"
      >
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </li>
    </ul>
  </ng-container>
  <ng-container *ngIf="!notesData.isLoading">
    <ng-container *ngIf="notesData.data; else emptyNoteBlock">
      <div
        class="head-text"
        *ngIf="notesData.data && notesData.data.length > 1"
      >
        All Worksheet Notes ({{ notesData.total_length || 0 }})
      </div>
      <section class="notes-container">
        <div
          class="note-block"
          *ngFor="let note of notesData.data; index as parentRowIndex"
        >
          <div class="header">
            {{ note.tabfullname }}
            <span *ngIf="note.value.length">({{ note.value.length }})</span>
          </div>
          <ng-container *ngIf="note.value.length; else emptyNoteBlock">
            <div
              class="description-block"
              *ngFor="let data of note.value; index as rowIndex"
            >
              <div class="comment-block">
                <span class="comment-header">Comment</span>
                <div [innerHtml]="data.text"></div>
                <div>
                  <button
                    nz-button
                    nzSize="small"
                    class="button feedback-btn"
                    [nzType]="data.isCommentActive ? 'primary' : 'default'"
                    (click)="
                      noteFeedback(
                        data.note_id,
                        data.display_name,
                        data.text,
                        note.tabfullname,
                        parentRowIndex,
                        rowIndex
                      )
                    "
                  >
                    <va-icon name="comment"></va-icon>
                    Feedback
                  </button>
                </div>
              </div>
              <div class="meta-section">
                <div class="note-meta">
                  <span class="meta-header">
                    Note Type
                  </span>
                  <span>{{ data.display_name }}</span>
                </div>
                <div class="note-meta">
                  <span class="meta-header">
                    Date
                  </span>
                  <span>{{ data.date }}</span>
                </div>
                <div class="note-meta">
                  <span class="meta-header">
                    Line Item
                  </span>
                  <span
                    class="note-link"
                    (click)="
                      redirectToNote(
                        'LineItem',
                        note.tabsn,
                        data.dapparameterid,
                        '',
                        data.basis
                      )
                    "
                    >{{ data.line_item }}</span
                  >
                </div>
                <div class="note-meta">
                  <span class="meta-header">
                    Period
                  </span>
                  <div class="period-list">
                    <span *ngFor="let dates of data.periods; last as isLast">
                      <span
                        class="note-link period-link"
                        *ngIf="dates.type !== 'Parameter'"
                        (click)="
                          redirectToNote(
                            'notLineItem',
                            note.tabsn,
                            dates.revisiondpid,
                            dates.periodstart,
                            data.basis
                          )
                        "
                      >
                        {{ dates.periodstart }}
                      </span>
                      <span *ngIf="data.type === 'Parameter'">
                        {{ dates }}
                      </span>
                      <span *ngIf="!isLast">,&nbsp;</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </section>
    </ng-container>
  </ng-container>
</section>

<ng-template #emptyNoteBlock>
  <div class="error-container">
    <div class="error-msg msg-position">
      <va-icon name="exclamation-triangle" class="info-icon"></va-icon>
      <span class="error-text">
        No notes available
      </span>
    </div>
  </div>
</ng-template>
